const {
  getLocation,
  getHistory,
  parseQueryString,
  createNewQueryString,
  clearFromQueryString
} = require("../../../../utils/location");

const isDefined = v => v !== undefined && v !== null;

const isEmptyString = v => typeof v === 'string' && v.trim().length === 0;

const isEmpty = v => !isDefined(v) || isEmptyString(v);

const isQueryStringEmpty = str => {
  const _str = (str || '').trim();
  const emptyValues = ['', '?', '?='];
  return emptyValues.some(v => v === _str);
}

// LAST - LINES AGGS SEARCH TEXT
const DEFAULT_PROPS = { searchText: '', isFuzzySearch: false };
const CACHE = {
  PROPS: {},
  isLoaded: false,
  URL_ROOT_KEY: 'LAST',
};

const _setLocal = (props = {}) => {
  const { searchText, isFuzzySearch } = props;
  const _searchText = (searchText || '').trim();
  const _isFuzzySearch = !!(isFuzzySearch && _searchText.trim().length);
  CACHE.PROPS = {
    searchText: _searchText,
    isFuzzySearch: _isFuzzySearch,
  };
};

const _clearLocal = () => { 
  CACHE.PROPS = {...DEFAULT_PROPS};
}

const loadCacheFromUrl = () => {
  const location = getLocation();
  const urlparams = parseQueryString(location?.search) || {};
  CACHE.PROPS = JSON.parse(urlparams[CACHE.URL_ROOT_KEY] || JSON.stringify(DEFAULT_PROPS));
  CACHE.isLoaded = true;
  return CACHE.PROPS;
}

const _writeToUrl = () => { 
  const location = getLocation();
  const history = getHistory();
  let queryString = clearFromQueryString(CACHE.URL_ROOT_KEY, location.search);
  if (!isEmpty(CACHE.PROPS?.searchText)) {
    queryString = createNewQueryString([CACHE.URL_ROOT_KEY, JSON.stringify(CACHE.PROPS)], queryString);
  }

  if (history?.pushState) {
    let newUrl = location.href.split('?')[0];
    if (!isQueryStringEmpty(queryString)) {
      newUrl += queryString;
    }
    if (newUrl !== location.href) {
      history.pushState({}, '', newUrl);
    }
  } else { 
    // fallback
    location.search = !isQueryStringEmpty(queryString) ? queryString : '';
  }

}

const setValueInUrl = (searchText, isFuzzySearch = false) => { 
  _setLocal({ searchText, isFuzzySearch });
  _writeToUrl();
}

const clearUrl = () => { 
  _clearLocal();
  _writeToUrl();
}

const LAST_UTIL = {
  loadCacheFromUrl,
  setValueInUrl,
  clearUrl,
  CACHE
}

export default LAST_UTIL;





